import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { ListItem, ListItemButton, ListItemText, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { Fragment } from 'react';
import { IEmailInboxRecordsDTO } from 'wisestep-api';
import { WsColors, WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';

import { extractContent } from '../../SentEmailLogs';
import { extractEmail, getTimeString, singleDataType } from '../helper';
type InboxListItemProps = {
  email: IEmailInboxRecordsDTO;
  index: number;
  onMailItemClick: (email) => void;
  handleContent: singleDataType;
};
export const InboxListItem = ({
  email,
  index,
  onMailItemClick,
  handleContent,
}: InboxListItemProps) => {
  const extractedContent = extractEmail(email.fromEmail);
  return (
    <ListItem
      key={index}
      sx={{
        padding: 0,
        backgroundColor: email.seen ? WsColors.TertiaryShades50 : WsColors.White,
      }}
      alignItems="flex-start"
      onClick={() => onMailItemClick(email)}
    >
      <ListItemButton selected={email.messageId === handleContent.content.messageId}>
        <ListItemText
          primary={
            <Grid container xs={12} direction="row" justifyContent="space-between">
              {email.seen ? (
                <DoneAllIcon style={{ color: WsColors.TheBlues500 }} />
              ) : (
                <DoneIcon style={{ color: WsColors.TheBlues500 }} />
              )}

              <WsTypography
                color={email.seen ? WsTypoColors.QUATERNARY : WsTypoColors.GREYTEXT}
                variant={WsTypoVariants.BODY1}
                bold={email.seen ? false : true}
              >
                {!isEmpty(extractedContent.name)
                  ? `${`${extractedContent.name}(${extractedContent.email})`.slice(0, 40)}...`
                  : extractEmail(email.fromEmail).email}
              </WsTypography>
              <WsTypography
                color={email.seen ? WsTypoColors.QUATERNARY : WsTypoColors.GREYTEXT}
                variant={WsTypoVariants.SUB_TITLE}
              >
                {getTimeString(email.receivedDate)}
              </WsTypography>
            </Grid>
          }
          secondary={
            <Fragment>
              <Grid container xs={12}>
                <Grid item xs={1} direction="row">
                  <ArrowRightIcon />
                </Grid>
                <Grid item xs={11}>
                  <Typography noWrap color={WsTypoColors.PRIMARY}>
                    {`${extractContent(email?.subject).toString().slice(0, 40)}  more... `}
                  </Typography>
                </Grid>
              </Grid>
            </Fragment>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};
